import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import { Modal, Form, Input, Select, message, Row, Col, DatePicker, AutoComplete, Drawer, Space, Spin } from 'antd'; // Checkbox , Switch
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { FetchContactDetails, FetchAllContact, FetchAllContactByDep } from '../../../Api/Services/ContactApiService'
import { getCompanyCase, createCase } from '../../../Api/Services/CaseApiServices'
import { getAllUsersData } from '../../../Api/Services/CommonApiService'
import { linkEmailForCase } from '../../../Api/Services/EmailApiSevices'
import { LeadDetailData, FetchAllLead, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices'
import { Button } from '../../../components/buttons/buttons';
import { CancelIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, nameOnChangeValidator, validateShortText, validateEmailField } from '../../../components/utilities/utilities';


const { Option } = Select;

const Popup = ({ addAccount, setAddAccount, AccountApi, Callback, pageType, id, successMessage, AutomationMessage }) => {
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [allList, setAllList] = useState([])
    const [users, setUsers] = useState([])
    const [leadInitial, setLeadInitial] = useState()
    const [disabled, setDisabled] = useState(false)
    const [creatorList, setCreatorList] = useState()
    const [validDate, setValidDate] = useState(null)
    const [uiReady, setUiReady] = useState(false)
    const [requesterType, setRequesterType] = useState()
    const handleClose = () => {
        setAddAccount(false);
        form.setFieldsValue({
            subject: null,
            number: null,
            type: null,
            caseOwner: null,
            origin: null,
            creator: null,
            email: null,
            phone: null,
            accountname: null,
        })
        setValidDate(null)
    }
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    async function setInitialData() {
        setLeadInitial({
            caseSubject: null,
            caseNumber: null,
            caseOwner: null,
            caseType: null,
            caseOrigin: null,
            casePriority: null,
            caseStatus: null,
            accountName: null,
            caseCreater: null,
            caseCreaterEmail: null,
            caseCreaterNumber: null,
            uploadFile: [],
            requestedResolutionDate: null,
            requesterType: null
        })
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const { subject, number, caseOwner, type, origin, creator, email, phone, accountname } = values;
        const payload = {
            caseSubject: normalizeValue(subject),
            caseNumber: normalizeValue(number),
            caseOwner: normalizeValue(caseOwner),
            caseType: normalizeValue(type),
            caseOrigin: normalizeValue(pageType === "Case" ? origin : "Email"),
            casePriority: normalizeValue("Low"),
            caseStatus: normalizeValue("New"),
            accountName: normalizeValue(accountname),
            caseCreater: normalizeValue(creator),
            caseCreaterEmail: normalizeValue(email),
            caseCreaterNumber: normalizeValue(phone),
            requestedResolutionDate: normalizeValue(validDate),
            uploadFile: [],
            requesterType: normalizeValue(requesterType),
        }

        const updatedFields = getChangedFields(payload, leadInitial);
        try {
            const response = await createCase(updatedFields)
            if (response.status === 201) {
                if (pageType === "Case") {
                    const isAutomation = response?.data?.message === AutomationMessage;
                    AccountApi("Create")
                    Callback(response.data.caseId)
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data?.message);
                        setTimeout(() => {
                            setAddAccount(false);
                        }, 2000);
                    }
                    else {
                        setAddAccount(false);
                        message.success(response?.data?.message)
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                } else {
                    const FormPayload =
                    {
                        subject: id.subject && id.subject !== "" ? id.subject : "(No Subject)",
                        mailId: id.mailId,
                        mailServiceId: id.mailServiceId,
                        date: id.date,
                        caseId: response.data.caseId,
                        from: id.from,
                        // to: id.to,
                    }
                    const caseEmail = await linkEmailForCase(FormPayload)
                    if (caseEmail.status === 201) {
                        message.success("Email linked with Case")
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    setAddAccount(false);
                }

            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Account number cannot exceed 15 characters")
            );
        }
        const getList = allList
        // .filter(item => item.caseId !== caseId)
        const existingCodes = getList.map(item => item.caseNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    const dealrestartDateChange2 = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setValidDate(formattedDate);
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.caseNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyCase()
            if (type === "Create") {
                const newCode = generateUniqueCode("CSE", data);
                form.setFieldsValue({
                    number: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales" || item.department === "Customer Care").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) {
            message.error(error)
        }
    }
    const setEmailDataToCase = async (data, creatorList) => {
        const matchedEntry = creatorList.find(entry => entry.email === data?.from?.address);
        if (matchedEntry) {
            if (matchedEntry?.type === "Leads") {
                try {
                    const responseData = await LeadDetailData(matchedEntry.id)
                    const response = responseData.data
                    form.setFieldsValue({
                        subject: data?.subject, caseOwner: null, type: null, isssueDate: null, phone: null,
                        creator: `${response?.first_name} ${response?.last_name}`, email: response?.primary_email, accountname: response.account_name,
                    })
                }
                catch (error) {
                    message.error(error)
                }
            }
            if (matchedEntry?.type === "Contacts") {
                try {
                    const responseData = await FetchContactDetails(matchedEntry.id)
                    const response = responseData.data
                    form.setFieldsValue({
                        subject: data?.subject, caseOwner: null, type: null, isssueDate: null, phone: null,
                        creator: `${response?.first_name} ${response?.last_name}`, email: response?.email, accountname: response.account_name,
                    })
                }
                catch (error) {
                    message.error(error)
                }
            }
        }
        else {
            form.setFieldsValue({
                subject: data?.subject, caseOwner: null, type: null,
                creator: data?.from?.name, email: data?.from?.address,
                accountname: null, phone: null, isssueDate: null,
            })
        }
    }
    async function CreatorListApi(type, emailData) {
        try {
            let Lead;
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
                contact = await FetchAllContactByDep()
            }
            else {
                Lead = await FetchAllLead()
                contact = await FetchAllContact()
            }
            const formattedLeads = Lead.map(item => ({
                id: item.leads_id,
                name: `${item.first_name} ${item.last_name}`,
                email: item.primary_email,
                type: "Leads",
            }));
            const formattedContacts = contact.map(item => ({
                id: item.contacts_id,
                name: `${item.first_name} ${item.last_name}`,
                email: item.email,
                type: "Contacts",
            }));
            const options = [...formattedLeads, ...formattedContacts];
            setCreatorList(options)
            if (type === "Email") {
                setEmailDataToCase(emailData, options)
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            CreatorListApi(pageType, id),
            getList("Create"),
            setInitialData(),
            setValidDate(null),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (addAccount) {
            if (pageType === "Case") {
                form.setFieldsValue({
                    subject: null, number: null, caseOwner: null, type: null, origin: null,
                    email: null, phone: null, accountname: null, isssueDate: null, creator: null
                })
            }
            fetchAll()
        }
    }, [addAccount])
    const handleSelect = async (value) => {
        setDisabled(true)
        form.setFieldsValue({
            creator: value.name,
            email: value.email,
        })
        if (value.type === "Contacts") {
            try {
                const responseData = await FetchContactDetails(value.id)
                const response = responseData.data
                form.setFieldsValue({
                    accountname: response.account_name
                })
            }
            catch (error) {
                message.error(error)
            }
            setRequesterType("Contacts")
        }
        else if (value.type === "Leads") {
            try {
                const responseData = await LeadDetailData(value.id)
                const response = responseData.data
                form.setFieldsValue({
                    accountname: response.account_name
                })
            }
            catch (error) {
                message.error(error)
            }
            setRequesterType("Leads")
        }
        else {
            setRequesterType("Others")
        }
    };
    const handleCreatorChange = () => {
        form.setFieldsValue({
            email: undefined,
            accountname: undefined,
        });
        setDisabled(false);
        setRequesterType("Others")
    };
    const PageContent = (
        < AddUser >
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false}
                    onFinish={(values) => onSubmit(values, 'save')}
                    onFinishFailed={onFinishFailed} >
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div style={{ margin: pageType === "Email" ? 40 : 0 }}>
                                <Row gutter={15}>
                                    <Col xs={24}>
                                        <div className="add-product-content">
                                            <Row gutter={30} style={{ padding: "0px 20px" }}>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Case Subject" name="subject" id="subject" rules={[{ required: true, message: 'Please enter case subject' }, {
                                                        validator: (_, value) => {
                                                            const error = validateShortText(value, 50);
                                                            if (error) {
                                                                return Promise.reject(new Error(error));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    },]}>
                                                        <Input placeholder="Enter Case Subject" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Case Number" name="number" id="number" rules={[{ required: true, message: 'Please enter case number' }, { validator: validateCode }]}>
                                                        <Input placeholder="Enter Case Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Assignee" name="caseOwner" id="caseOwner" rules={[{ required: true, message: 'Please select case owner' }]}>
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Assignee"
                                                            showSearch optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            }>
                                                            {users}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Case Type" name="type" id="type" rules={[{ required: true, message: 'Please select case type' }]} >
                                                        <Select style={{ width: '100%' }} allowClear placeholder="Select Case Type" onChange={(value) => form.setFieldsValue({ type: value || null })}>
                                                            <Option value="Service Request">Service Request</Option>
                                                            <Option value="Problem">Problem</Option>
                                                            <Option value="Question">Question</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                {pageType === "Case" ?
                                                    <Col span={8} style={{ marginBottom: 30 }} >
                                                        <Form.Item label="Case Origin" name="origin" id="origin" rules={pageType === "Case" ? [{ required: true, message: 'Please select case origin' }] : [{ required: false }]}>
                                                            <Select style={{ width: '100%' }} allowClear placeholder="Select Case Origin" onChange={(value) => form.setFieldsValue({ origin: value || null })}>
                                                                <Option value="Email">Email</Option>
                                                                <Option value="Phone">Phone</Option>
                                                                <Option value="Web">Web</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col> : ""}
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Requester" name="creator" id="creator"
                                                        rules={[{ required: true, message: 'Please select case creator' }, {
                                                            validator: (_, value) => {
                                                                const error = nameOnChangeValidator(value, 50);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }]}>

                                                        <AutoComplete
                                                            // disabled={disabled}
                                                            options={creatorList?.map(option => ({
                                                                label: (<div className='UserList-dropdown' title={`${option.name} (${option.type})`}>
                                                                    <div>
                                                                        <span className={`details_span_Tag ${option.type === "Leads" ? "LeadIcon" : "ContactIcon"}`} style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                            {option.name.slice(0, 1).toUpperCase()}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                                                                        <p style={{ margin: 0 }}>({option.type})</p>
                                                                    </div>
                                                                </div>),
                                                                 value: `${option.name}-${option.type}-${option.id}`,
                                                                data: option
                                                            }))}
                                                            onChange={handleCreatorChange}
                                                            onSelect={(value, option) => handleSelect(option.data)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Type or select an option"
                                                            filterOption={(inputValue, option) =>
                                                                option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                            }
                                                        >
                                                            <Input />
                                                        </AutoComplete>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Requester Email" name="email"
                                                        id="email" rules={[{ required: true, message: 'Please enter case creator email', }, {
                                                            validator: (_, value) => {
                                                                const error = validateEmailField(value, 50);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }]}>
                                                        <Input placeholder="Enter Requester Email" disabled={disabled} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Requester Phone Number" name="phone"
                                                        id="phone" rules={[{
                                                            validator: (_, value) => {
                                                                const error = mobileOnChangeValidator(value, 20);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }]}> <Input placeholder="Enter Requester Phone Number" pattern="^\+?[0-9]{1,14}$" />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Account Name" name="accountname" id="accountname" rules={[{
                                                        validator: (_, value) => {
                                                            const error = nameOnChangeValidator(value, 50);
                                                            if (error) {
                                                                return Promise.reject(new Error(error));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }]}>
                                                        <Input placeholder="Enter Account Name" disabled={disabled} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 30 }} >
                                                    <Form.Item label="Requested Resolution Date" name="isssueDate" id="isssueDate"
                                                        rules={[{ required: true, message: 'Please select requested resolution date' },]}>
                                                        <DatePicker allowClear={false} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} onChange={dealrestartDateChange2} disabledDate={disabledDate} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form>
            </div>
        </AddUser >
    )
    const FooterContent = (uiReady ? [<div className="form_action_button">
        <Button
            className="gray-button"
            onClick={handleClose} size="small"
        >
            <FeatherIcon icon="x" />Cancel
        </Button>
        <Button size="small" onClick={() => form.submit()} className="button_colors" loading={deleteClick} disabled={deleteClick} >
            {!deleteClick && <FeatherIcon icon="save" />}Save
        </Button>
    </div>] : false)
    return (
        <>
            {pageType === "Email" ?
                <Drawer
                    className='Drawer-Header-Pages'
                    bodyStyle={{ padding: 0 }}
                    closable={false}
                    placement="right"
                    title="Add Case"
                    open={addAccount}
                    width="60%"
                    extra={
                        <Space>
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Close'
                                onClick={() => handleClose()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        handleClose()
                                    }
                                }}
                                aria-label='Close'
                            > <CancelIcon width={24} height={24} /></div>
                        </Space>
                    }
                    footer={FooterContent}>
                    {uiReady ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        {PageContent}
                    </Scrollbars>
                        : <div className="spin">
                            <Spin />
                        </div>}
                </Drawer>
                :
                <Modal
                    title="Add Case"
                    open={addAccount}
                    onCancel={handleClose}
                    maskClosable={false}
                    width={800}
                    // style={{ top: 70 }}
                    footer={FooterContent}
                >
                    {uiReady ? <>{PageContent}</> :
                        <div style={{ height: "500px" }} className="spin">
                            <Spin />
                        </div>}
                </Modal >}
        </>
    );
};

Popup.propTypes = {
    addAccount: PropTypes.bool.isRequired,
    setAddAccount: PropTypes.func.isRequired,
    Callback: PropTypes.func.isRequired,
    AccountApi: PropTypes.func.isRequired,
    pageType: PropTypes.string.isRequired,
    id: PropTypes.object.isRequired,
    successMessage: PropTypes.func.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
};

export default Popup;
